import AuthRender from './AuthRender';

export default AuthRender;
export * from './AuthRender';
